module.exports = __webpack_public_path__ + "static/media/IMG_6965.9eeee4a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/square/IMG_6965.jpg
// module id = 142
// module chunks = 0